import React, { useState } from 'react';
import './loginPage.css';
import loginApi from '../../networking/apis/login';

interface LoginPageStateType {
  showAlert: boolean;
  alertMessage: string;
  alertType: 'warning' | 'confirmation';
}

const LoginPage: React.FC<{ onLogin: (token: string, email: string ) => void }> = ({ onLogin }) => {
  const [email, setEmail] = useState<string>('');
  const [password, setPassword] = useState<string>('');
  const [showAlert, setShowAlert] = useState<boolean>(false);
  const [alertMessage, setAlertMessage] = useState<string>('');
  const [alertType, setAlertType] = useState<string>('');

  const alert = (message: string, type: LoginPageStateType["alertType"] = 'warning') => {
    setAlertMessage(message)
    setAlertType(type)
    setShowAlert(true)
    
    setTimeout(() => {
      setAlertMessage('')
      setAlertType('')
      setShowAlert(false)
    }, 2000); 
  };

  const handleSubmit = async(e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    
    const loginData = await loginApi(email, password)
    if (loginData && loginData?.status === true && loginData?.token) {
      const token =loginData?.token
      onLogin(token, email);
    } else {
      alert('Login Failed, Check Email or Password')
    }
  };

  return (
    <div className="login-container">
      <form className="login-form" onSubmit={handleSubmit}>
        <h2>Login</h2>

        <div className="input-group">
          <label htmlFor="email">Email</label>
          <input
            id="email"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
        </div>

        <div className="input-group">
          <label htmlFor="password">Password</label>
          <input
            id="password"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
        </div>

        <button type="submit" className="login-button">
          Sign In
        </button>
      </form>
      {showAlert && (
          <div className={`alert-popup ${showAlert ? 'show' : ''} `}>
              <div className={`alert-inner ${alertType}`}>
                  <p>{alertMessage}</p>
              </div>
          </div>
      )}
    </div>
  );
};

export default LoginPage;